module.exports = __webpack_public_path__ + "static/media/01C.7f8f299d.png";